import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { AuthService, User } from '@app/core/auth';
import { StaffService } from '@app/core/staff';
import { StaffRole } from '@app/core/staff/store/staff.model';

@Component({
  selector: 'cnc-auth-form-modal',
  templateUrl: './auth-form-modal.component.html',
  styleUrls: ['./auth-form-modal.component.scss'],
})
export class AuthFormModalComponent implements OnInit {
  hide :boolean = true;
  loading :boolean = false;
  submitted :boolean = false;
  pageTitle :string = this.translate.instant('TITLES.NEW_STAFF');
  formData :UntypedFormGroup;
  roles :StaffRole[];
  loginUser :any;

  @Input() staff;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    public staffService :StaffService,
    private toastr :ToastrService,
    private translate :TranslateService,
    private authService :AuthService,
  ) {}

  ngOnInit() {
    this.loginUser = this.authService.getUser();
    this.staffService.roles$.subscribe((roles) => {
      if (this.loginUser.role == 88) {
        this.roles = roles.filter(
          (role :any) => role.role_id == 2 || role.role_id == 88,
        );
      } else {
        this.roles = roles;
      }
    });

    this.formData = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
      mobile: [''],
      role: [2],
      prwx: [null],
      po_approval_permission: [null],
      parent_id: [0, Validators.required],
      phone: [''],
      com_gmv: [0, Validators.required],
      com_sub: [0, Validators.required],
      receive_payment_due_notif: [false],
    });

    if (this.staff) {
      this.pageTitle = this.translate.instant('TITLES.UPDATE_PROFILE');
      this.formData.patchValue(this.staff);
      if (this.staff.receive_payment_due_notif == 1) {
        this.formData.get('receive_payment_due_notif').patchValue(true);
      }
      if (this.staff.prwx == 1) {
        this.formData.get('prwx').patchValue(true);
      } else {
        this.formData.get('prwx').patchValue(false);
      }
      this.formData.get('email').disable();
      this.formData.get('password').clearValidators();
    }
  }

  handleSubmit(e :SubmitEvent) {
    e.preventDefault();

    this.#submit();
  }

  #submit() {
    this.submitted = true;
    if (this.formData.invalid) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FORM_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FORM_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    const data = this.formData.value;
    if (!data.parent_id) {
      data.parent_id = 0;
    }
    if (data.role >= 88) {
      data.is_admin = 1;
    } else {
      data.is_admin = 0;
    }
    if (data.prwx) {
      data.prwx = 1;
    } else {
      data.prwx = 7;
    }
    if (this.loginUser.role == 8) {
      data.parent_id = this.loginUser.id;
    }
    if (data.receive_payment_due_notif) {
      data.receive_payment_due_notif = 1;
    } else {
      data.receive_payment_due_notif = 0;
    }

    if (data.po_approval_permission) {
      data.po_approval_permission = 1;
    } else {
      data.po_approval_permission = 0;
    }

    if (parseInt(data.role) == 1 && parseInt(data.parent_id) == 0) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FACTORY_ADMIN_REQ.TITLE'),
        text: this.translate.instant('MESSAGES.FACTORY_ADMIN_REQ.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    this.loading = true;
    if (this.staff && this.staff.id) {
      this.staffService.updateRecord(data, this.staff.id).subscribe(
        (resp :any) => {
          this.toastr.success(
            this.translate.instant('MESSAGES.UPDATE_SUCCESS.TEXT'),
            this.translate.instant('MESSAGES.UPDATE_SUCCESS.TITLE'),
          );
          this.activeModal.close(resp.record);
        },
        (errorResp) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: errorResp.error.message,
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          });
        },
      );
    } else {
      this.staffService.createRecord(data).subscribe(
        (resp :any) => {
          this.toastr.success(resp.message, 'Save Successful!');
          this.activeModal.close(resp.record);
        },
        (errorResp) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: errorResp.error.message,
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          });
        },
      );
    }
  }
}
